var menuListStatic = {};

function multiMenuListNS() {
	//this.scroll = new Scroller("#panos","#ui");
	menuListStatic = this;
	
	$("#panos").html("");
}

multiMenuListNS.prototype = {
	lastItem:null,
	lastSubMenu:null,
	items:[],
	
	back: function() {
		var chs = player.currentHistoryState;
		
		history.back();

		$(chs.current).hide();
		
		$(chs.parent).show();
	},
	
	multiBack: function(event) {
		if (player.list.lastItem != null) {
			$("#" + player.list.lastItem.id).hide();
			player.list.lastItem = player.list.lastItem.parent;
			if (player.list.lastItem != null) $("#" + player.list.lastItem.id).show();
			else history.back();
		} else {
			history.back();
		}
		
		event.preventDefault();
		/*
		var cp = $(this).attr("data-count");
		var max = $("#panosback a").length;
		
		if (cp == undefined) cp = 0;
		
		if (max == 1) history.back();
		
		for(var i = 0; i < max - cp; i ++) {
			history.back();
		}
		*/
	},
	
	openMenu: function(item) {
		//console.log("open submenu " + pdiv);
		
		if (player.list.lastSubMenu != null) $(player.list.lastSubMenu).hide();

		if (item == null) {

			if (player.list.lastItem != null) $("#" + player.list.lastItem.id).hide();
			$("#rootmenu").show();
		
		} else if (item.id != "") {
			if (player.list.lastItem != null) {
				$("#" + player.list.lastItem.id).hide();
			} else {
				$("#rootmenu").hide();
			}
			$("#" + item.id).show();
		}
		
		player.list.lastItem = item;
	},
	
	showSubmenu: function() {		
		var self = menuListStatic.currentItem;
		var sid = "#" + $(self).attr("data-sub");
		var parent = $(self).attr("data-parent");

		var stateObj = { "current": sid, "parent": parent };

		//player.list.lastItem = { "id": sid, "parent": parent };

		//console.log(self);
		
		//if (menuListStatic.scroll.isScrolling()) {
		//	return;
		//}
		
		player.addToHistory(stateObj, $(self).attr("data-title"), sid);
		
		/*
		var nm = $("<div class='breadcrumb'><img src='assets/bc_div.png' height='20'><a href='javascript:void(null);' data-count='" + $("#panosback a").length + "'>" + $(this).attr("data-title") + "</a><img src='assets/bc_div_end.png' height='20' style='float:right;display:none;' class='bcend'></div>");
		
		$("#panosback .breadcrumb").last().children(".bcend").css("display", "block");
		
		$("#panosback").append(nm);
		
		nm.on("click", "a", player.list.multiBack);
		*/
		//$(parent).css("opacity","0");
		$(parent).hide();
		
		$(sid).show();
		//$(sid).css("opacity","1");
		
		player.list.lastSubMenu = sid;

		/*
		$(parent).css("transform","translate3d(-" + player._width + "px,0px,0x)");
		$(parent).css("-webkit-transform","translate3d(-" + player._width + "px,0px,0px)");
		$(parent).css("-moz-transform","translate3d(-" + player._width + "px,0px,0px)");
		
		$(sid).show();
		$(sid).css("transform","translate3d(0px,0px,0px)");
		$(sid).css("-webkit-transform","translate3d(0px,0px,0px)");
		$(sid).css("-moz-transform","translate3d(0px,0px,0px)");
		*/

		//this.scroll.calculateBounds();
		
		//event.preventDefault();
	},

	loadRec: function(data, parent, apnd, parentData, parentItem) {
		var speak = false;

		if (parentData != null) {
			elem = $("<div class='folder' style='border-bottom:2px solid #ffffff;'><a href='javascript:void(null);' data-title='" + parentData.title + "' style='color: #919191;'><div class='lglyph'>&laquo;</div>" + parentData.title  + "</a></div>");
			$(apnd).append(elem);
			
//			elem.children("a").on(Events.pointer.down, this.multiBack);
			elem.children("a").on(Events.pointer.up, this.back);
		} else {
			speak = true;
		}
		
		for(var i = 0; i < data.length; i ++) {
		
			if (data[i].pano_id == player.ident) {
				//navbar.setMenu(data,parentData, "sub_" + parent);
				navbar.setMenu(parentItem, data[i]);
			}
			
			if (data[i].childs != undefined) {
				elem = $("<div class='folder'><a href='javascript:void(null);' data-itemtap='menuListStatic.showSubmenu()' data-speak='" + (speak?"1":"0") + "' data-parent='" + apnd + "' data-title='" + data[i].title + "' data-sub='sub_" + parent + "_" + i + "'>" + data[i].title  + "</a><div class='glyph'>&raquo;</div></div>");
				var ts3d = "translate3d(" + player._width + "px, 0px, 0px)";
//				sub = $("<div id='sub_" + parent + "_" + i + "' style='transform:" + ts3d + ";-webkit-transform:" + ts3d + ";display:none;' class='menu'></div>");
				sub = $("<div id='sub_" + parent + "_" + i + "' style='display:none;' class='menu'></div>");
				$(apnd).append(elem);
				$("#panos").append(sub);
				
				//elem.children("a").on("touchend", this.showSubmenu);				
				
				var item = {"id" : "sub_" + parent + "_" + i, "parent" : parentItem, "title" : data[i].title};
				this.items.push(item);
				
				this.loadRec(data[i].childs, parent + "_" + i, "#sub_" + parent + "_" + i, data[i], item);
			} else {
				if (data[i].pano_id.substr(0,5) == "link=") 
					elem = $("<div class='folder'><a href='javascript:void(null);' data-itemtap='menuListStatic.openUrl(\"http://" + data[i].pano_id.substr(5) + "\", true, 0);' data-speak='" + (speak?"1":"0") + "' data-title='" + data[i].title + "'>" + data[i].title  + "</a></div><div id='sub_" + parent + "_" + i + "' style='margin-left:50px;'></div>");
				else if (data[i].pano_id.substr(0,6) == "hlink=") {
					if (player.offline) {
						var fileUrl = data[i].pano_id.substr(6);
						fileUrl = fileUrl.replace('wkrajwkraj.nazwa.pl/dane/Zamosc_Franciszkanie/', './storage/library/4339/Film/');
						elem = $("<div class='folder'><a href='javascript:void(null);' data-itemtap='menuListStatic.openUrl(\"" + fileUrl + "\", true, 0);' data-speak='" + (speak?"1":"0") + "' data-title='" + data[i].title + "'>" + data[i].title  + "</a></div><div id='sub_" + parent + "_" + i + "' style='margin-left:50px;'></div>");
					} else {
						elem = $("<div class='folder'><a href='javascript:void(null);' data-itemtap='menuListStatic.openUrl(\"https://" + data[i].pano_id.substr(6) + "\", true, 0);' data-speak='" + (speak?"1":"0") + "' data-title='" + data[i].title + "'>" + data[i].title  + "</a></div><div id='sub_" + parent + "_" + i + "' style='margin-left:50px;'></div>");
					}
				} else {
					look = null;
					if (data[i].look_at) look = data[i].look_at;
					if (data[i].look_at_y != null && data[i].look_at_y != undefined) look += "," + data[i].look_at_y;
					else if (look == null) look = 0;
					elem = $("<div class='folder'><a href='javascript:void(null);' data-itemtap='menuListStatic.openUrl(\"" + data[i].pano_id + "\", false, \"" + look + "\");' data-speak='" + (speak?"1":"0") + "' data-title='" + data[i].title + "'>" + data[i].title  + "</a></div><div id='sub_" + parent + "_" + i + "' style='margin-left:50px;'></div>");
				}
				
//				elem = $("<div class='panolink'><a href='index.php?id=" + data[i].item[1] + "'><img src='" + data[i].thumb + "' width='200' height='100'><div class='bg'><span>" + data[i].item[0].title + "</span></div></a></div>");
				$(apnd).append(elem);
			}

			if (speak) {
				SpeechManager.prepareTip(data[i].title, "TOPMENU");
			}

		}
		this.bindTapEvents($(apnd));
		//this.scroll.calculateBounds();
	},
	
	openUrl: function(url, blank, dir) {
		/*
		if (menuListStatic.scroll.isScrolling()) {
			return;
		}
		*/
		if (!blank) 
			if (url == "quiz") {
				player.hideMenu();
				Quiz.open(dir);				
			} else if (url == "folder") {
				player.hideMenu();
				Library.open(dir);				
			} else {
				player.go(url, dir);
			}
			//document.location = url;
		else {
			var win = window.open(url, '_blank');
			if (win == null || typeof(win)=='undefined') {
				if (confirm("Twoja przeglądarka blokuje otwieranie nowych okien. Czy chcesz otworzyć ten link w bieżącym oknie ?")) {
					document.location = url;
				}
			}
		}
	},
	
	loadPanoList: function(data) {
		var currentpano;
		var current = {id:"-1", title:"Lista panoram"};
		current.panos = [];
		
		//this.scroll = new Scroller("#panos","#ui");
		
		data = player.current.menu;
				
		//console.log(data);
		
		navbar.setTitle(player.current.place_name);
		
//		if (!player.imagesLoaded) {
			
			var root = $("<div class='menu' id='rootmenu'></div>");
			$("#panos").append(root);
			
			var parentItem = {"id" : "rootmenu", "parent" : null, "title" : ""};
			this.items.push(parentItem);
			
			this.loadRec(data, "", "#rootmenu", null, parentItem);
			/*
			for(var i = 0; i < data.length; i ++) {
				elem = $("<div class='folder'><a href='javascript:void(null);' onclick='player.list.loadFolder(" + player.folders.length + ");'>" + data[i].item[0].title  + "</a></div><div id='folder_" + player.folders.length + "'></div>");
				
				$("#panos").append(elem);
			}	
			*/
			player.imagesLoaded = true;
//		}
	},
	
	bindTapEvents:function(node) {
		var self = this;
		
		node.find("[data-itemtap]").each(function(idx, item) {
			
			var a = $(item);
			a.attr("data-vlistno",idx);
			
			a.on(Events.pointer.down, function(e) {
				var pointer = getPointerEvent(e);
				var ia = $(this);
				var item = menuListStatic;
				var action = ia.attr("data-itemtap");
				item.cachedX = pointer.pageX;
				item.cachedY = pointer.pageY;
				item.currentX = pointer.pageX;
				item.currentY = pointer.pageY;
				item.touchStarted = true;
				
				menuListStatic.currentItem = this;
				
				self = this;
				
				$(this).css("background-color", "#121212");

				setTimeout(function () {
						//if ((item.cachedX === item.currentX) && !item.touchStarted && (item.cachedY === item.currentY)) {
						if (Math.abs(item.cachedX - item.currentX) < 5 && !item.touchStarted && Math.abs(item.cachedY === item.currentY) < 5) {
							//console.log(action);

							var fn = new Function(action);
							fn();
							
							//self.loader.show();
							//setTimeout(fn, 200);							
						}
					},300);				
				
				
			});
			
			a.on(Events.pointer.move, function(e) {
				var pointer = getPointerEvent(e);
				var ia = $(this);
				var item = menuListStatic;
				item.currentX = pointer.pageX;
				item.currentY = pointer.pageY;
			});
			
			a.on(Events.pointer.up, function(e) {
				var ia = $(this);
				var item = menuListStatic;
				var action = ia.attr("data-itemtap");

				item.touchStarted = false;
				//$(this).html(Math.abs(item.cachedX - item.currentX) + " , " + Math.abs(item.cachedY - item.currentY));
				
				if (ia.attr("data-speak") == "1") {
					SpeechManager.speakTip(ia.attr("data-title"), "TOPMENU");
				}

				if (Math.abs(item.cachedX - item.currentX) < 10 && Math.abs(item.cachedY - item.currentY) < 10) {
						//$(this).html(action);
						//var fn = new Function(action);
						//fn();
					}

				$(this).css("background-color", "#252525");
			});
		});
		
		//this.scroll.calculateBounds();
	}
	
}